import API_URLS from "@constants/apiUrls";
import { api } from "services/customBaseQuery";

export const issueCreditsAPI = api.injectEndpoints({
  endpoints: (build) => ({
    createPromotion: build.mutation<any, any>({
      query: (data) => ({
        url: API_URLS.PROMOTIONS,
        method: "POST",
        body: data,
        credentials: "include",
      }),
    }),
    fetchPromotionsList: build.query<
      any,
      { keyword?: string; url?: string } | string | void
    >({
      query: (params) => {
        // If params is a string (pagination URL), use it directly
        if (typeof params === "string") {
          return {
            url: params,
            method: "GET",
            credentials: "include",
          };
        }

        // If params is an object with url property, use that URL
        if (params?.url) {
          return {
            url: params.url,
            method: "GET",
            credentials: "include",
          };
        }

        // Otherwise, build URL with query parameters
        const queryString = params
          ? `?${new URLSearchParams(params as any).toString()}`
          : "";
        return {
          url: `${API_URLS.PROMOTIONS}${queryString}`,
          method: "GET",
          credentials: "include",
        };
      },
      providesTags: ["Promotions"],
    }),
    uploadExcelFile: build.mutation<any, FormData>({
      query: (formData) => ({
        url: API_URLS.EXCEL_UPLOAD,
        method: "POST",
        body: formData,
        credentials: "include",
      }),
    }),
    fetchExcelUploadList: build.query<any, { url: string; method?: string }>({
      query: ({ url, method = "GET" }) => ({
        url,
        method,
        credentials: "include",
      }),
    }),

    excelUploadAction: build.mutation<
      any,
      {
        url: string;
        method: "POST" | "PUT" | "PATCH" | "DELETE";
        body?: any;
      }
    >({
      query: ({ url, method, body }) => ({
        url,
        method,
        body,
        credentials: "include",
      }),
    }),
    deleteExcelUploadItem: build.mutation<any, string>({
      query: (url) => ({
        url,
        method: "DELETE",
        credentials: "include",
      }),
    }),
    getSampleFile: build.query<any, void>({
      query: () => ({
        url: API_URLS.DOWNLOAD_SAMPLE_FILE,
        method: "GET",
        credentials: "include",
      }),
    }),
  }),
});

export const {
  useCreatePromotionMutation,
  useFetchPromotionsListQuery,
  useUploadExcelFileMutation,
  useFetchExcelUploadListQuery,
  useExcelUploadActionMutation,
  useDeleteExcelUploadItemMutation,
  useGetSampleFileQuery,
  useLazyGetSampleFileQuery,
} = issueCreditsAPI;
